import React from "react"
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Stack,
  Divider,
  Button
} from "@mui/material"
import { MessageCircle, Home, FileText, ArrowRight } from "lucide-react"
import { NavLink } from "react-router-dom"

export function InquiriesWidget() {
  const totalInquiries = 15

  const inquiries = [
    {
      id: 1,
      type: "Property",
      description: "Inquiry for 456 Elm St.",
      count: 8,
      icon: <Home size={18} color="#3B82F6" />, // Tailwind blue-500
    },
    {
      id: 2,
      type: "RFP",
      description: "Inquiry for new office space RFP.",
      count: 7,
      icon: <FileText size={18} color="#8B5CF6" />, // Tailwind purple-500
    },
  ]
  const textColor = "#0d2561";

  return (
    <Card elevation={3} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: 2 }}>
      
      <CardContent sx={{ flexGrow: 1, }}>
        {/* Title */}
        <Typography
          variant="h6"
          sx={{ color: textColor, fontWeight: 600, fontSize: "18px" }}
        >
          Inquiries
        </Typography>
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          <MessageCircle size={32} color="#0d2561" /> {/* primary */}
          <Box>
            <Typography variant="h5" color="primary" fontWeight="bold" sx={{ color: "#0d2561" }}>
              {totalInquiries}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total Inquiries
            </Typography>
          </Box>
        </Box>

        <Stack spacing={2}>
          {inquiries.map((inquiry) => (
            <Box key={inquiry.id} display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1.5}>
                {inquiry.icon}
                <Typography variant="body2" sx={{ color: "#0d2561" }}>{inquiry.description}</Typography>
              </Box>
              <Typography variant="body2" fontWeight={500} color="primary" sx={{ color: "#0d2561" }}>
                {inquiry.count}
              </Typography>
            </Box>
          ))}
        </Stack>
        <Box textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{ color: textColor, textTransform: "none", fontSize: "0.875rem" }}
              endIcon={<ArrowRight size={16} />}
            >
              View all inquiries
            </Button>
          </NavLink>
        </Box>

        
      </CardContent>
    </Card>
  )
}